export default function convertStatus(statusString: string): string {
  const statusMap: Record<string, string> = {
    Sent: "Levererat",
    Pending: "Inväntar status",
    Held: "Stoppad, flera misslyckade mail till denna adress",
    HardFail: "Kunde inte leverera. Möjligen felaktig mailadress",

    ADMIN_APPROVED: "Godkänd av admin",
    APPROVED: "Godkänd av annonsör",
    CHANGE_REQUESTED: "Ändring efterfrågad",
    PENDING: "Inväntar granskning",
    CANCELED: "Avbruten av admin"
  };

  return statusMap[statusString] || statusString;
}
